import { useTranslation } from 'react-i18next';

import { Button } from '../components/Button';
import { useLocatorStore } from '../store/useLocatorStore';

export function RadiusModal() {
  const radiusUnit = useLocatorStore((state) => state.radiusUnit);
  const setRadius = useLocatorStore((state) => state.setRadius);
  const radius = useLocatorStore((state) => state.radius);
  const setRadiusUnit = useLocatorStore((state) => state.setRadiusUnit);
  const { t } = useTranslation();

  function handleDataLayer() {
    // @ts-expect-error
    if (window.dataLayer) {
      // @ts-expect-error
      window.dataLayer.push({
        'event': 'V3_clinic_finder_radius_boost',
      });
    }
  }

  const radiusUnitTranslated = radiusUnit === 'km' ? t('km') : t('miles');

  return (
    <dialog id="radius-modal" className="daisy-modal">
      <div className="daisy-modal-box max-w-[328px] rounded-none bg-white md:mt-[-100px]">
        <form method="dialog">
          <button
            type="submit"
            className="daisy-btn daisy-btn-circle text-[1em] daisy-btn-ghost absolute end-[0.5em] top-[0.5em]"
          >
            ✕
          </button>
        </form>
        <h3 className="text-[1.125em] font-normal capitalize tracking-[-0.0675em]">
          {t('radius')}
        </h3>

        <div className="mt-[24px] flex font-medium uppercase text-[1em]">
          <Button
            text={t('km')}
            className="inverted flex-grow"
            type="inverted"
            isActive={radiusUnit === 'km'}
            onClick={() => setRadiusUnit('km')}
          />
          <Button
            text={t('miles')}
            className="inverted flex-grow"
            type="inverted"
            isActive={radiusUnit === 'miles'}
            onClick={() => setRadiusUnit('miles')}
          />
        </div>

        <div className="mt-[20px] flex flex-col justify-center gap-4 font-light text-black">
          <div className="daisy-form-control">
            <label className="items-center text-light label flex cursor-pointer justify-start gap-6 text-[1em]">
              <input
                type="radio"
                onChange={() => {
                  setRadius(0);
                  handleDataLayer();
                }}
                checked={radius === 0}
                className="daisy-radio-primary  daisy-radio-lg border-2 border-solid border-[#CCD7D9] hover:daisy-radio-primary active:daisy-radio-primary focus:ring-offset-0 "
              />
              <span>{t('This area only')}</span>
            </label>
          </div>

          <div className="daisy-form-control">
            <label className="items-center text-light label flex cursor-pointer justify-start gap-6 text-[1em]">
              <input
                type="radio"
                onChange={() => {
                  setRadius(1);
                  handleDataLayer();
                }}
                checked={radius === 1}
                className="daisy-radio-primary  daisy-radio-lg  border-2 border-solid border-[#CCD7D9] hover:daisy-radio-primary focus:daisy-radio-primary active:daisy-radio-primary"
                value={1}
              />
              <span>1 {radiusUnitTranslated}</span>
            </label>
          </div>

          <div className="daisy-form-control">
            <label className="items-center text-light label flex cursor-pointer justify-start gap-6 text-[1em]">
              <input
                type="radio"
                onChange={() => {
                  setRadius(3);
                  handleDataLayer();
                }}
                checked={radius === 3}
                className="daisy-radio-primary  daisy-radio-lg  border-2 border-solid border-[#CCD7D9] hover:daisy-radio-primary focus:daisy-radio-primary active:daisy-radio-primary"
                value={3}
              />
              <span>3 {radiusUnitTranslated}</span>
            </label>
          </div>

          <div className="daisy-form-control">
            <label className="items-center text-light label flex cursor-pointer justify-start gap-6 text-[1em]">
              <input
                type="radio"
                onChange={() => {
                  setRadius(5);
                  handleDataLayer();
                }}
                checked={radius === 5}
                className="daisy-radio-primary  daisy-radio-lg  border-2 border-solid border-[#CCD7D9] hover:daisy-radio-primary focus:daisy-radio-primary active:daisy-radio-primary"
                value={5}
              />
              <span>5 {radiusUnitTranslated}</span>
            </label>
          </div>

          <div className="daisy-form-control">
            <label className="items-center text-light label flex cursor-pointer justify-start gap-6 text-[1em]">
              <input
                type="radio"
                onChange={() => {
                  setRadius(10);
                  handleDataLayer();
                }}
                checked={radius === 10}
                className="daisy-radio-primary  daisy-radio-lg  border-2 border-solid border-[#CCD7D9] hover:daisy-radio-primary focus:daisy-radio-primary active:daisy-radio-primary"
                value={10}
              />
              <span>10 {radiusUnitTranslated}</span>
            </label>
          </div>

          <div className="daisy-form-control">
            <label className="items-center text-light label flex cursor-pointer justify-start gap-6 text-[1em]">
              <input
                type="radio"
                onChange={() => {
                  setRadius(20);
                  handleDataLayer();
                }}
                checked={radius === 20}
                className="daisy-radio-primary  daisy-radio-lg  border-2 border-solid border-[#CCD7D9] hover:daisy-radio-primary focus:daisy-radio-primary active:daisy-radio-primary"
                value={20}
              />
              <span>20 {radiusUnitTranslated}</span>
            </label>
          </div>

          <div className="daisy-form-control">
            <label className="items-center text-light label flex cursor-pointer justify-start gap-6 text-[1em]">
              <input
                type="radio"
                onChange={() => {
                  setRadius(50);
                  handleDataLayer();
                }}
                checked={radius === 50}
                className="daisy-radio-primary  daisy-radio-lg  border-2 border-solid border-[#CCD7D9] hover:daisy-radio-primary focus:daisy-radio-primary active:daisy-radio-primary"
                value={50}
              />
              <span>50 {radiusUnitTranslated}</span>
            </label>
          </div>

          <div className="daisy-form-control">
            <label className="items-center text-light label flex cursor-pointer justify-start gap-6 text-[1em]">
              <input
                type="radio"
                onChange={() => {
                  setRadius(100);
                  handleDataLayer();
                }}
                checked={radius === 100}
                className="daisy-radio-primary  daisy-radio-lg  border-2 border-solid border-[#CCD7D9] hover:daisy-radio-primary focus:daisy-radio-primary active:daisy-radio-primary"
                value={100}
              />
              <span>100 {radiusUnitTranslated}</span>
            </label>
          </div>
        </div>
      </div>
    </dialog>
  );
}
